import type { FaireProductEntity } from "../../entity_types/product";

export const pom_pom_4: FaireProductEntity = {
  token: "pom-pom-4",
  type: "product",
  name: "Popcorn, Sour Cream & Onion",
  brandName: "Pom Pom Popcorn by Bessou",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a5c5c45080a962301672226ff2b7efb078fead795b636b4a9570913e82fb2845.webp",
  priceDollars: 10,
  msrpDollars: 16,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
